<template>
  <b-card
    v-if="projects.length"
    border-variant="light"
    bg-variant="light"
    body-class="px-3 py-3"
    data-test="weekly-card"
  >
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <div class="mb-2 mb-sm-0">
        <div class="font-weight-bold">Weekly Timesheet</div>
        <div class="text-muted small">
          Fill in your week and send it to your supervisor for approval.
        </div>
      </div>
      <b-button
        variant="primary"
        :to="{ name: 'weekly-timesheet' }"
        data-test="weekly-open"
      >
        Open
      </b-button>
    </div>
  </b-card>
</template>

<script>
// Shown on the tradie's home page only when a project of theirs has weekly
// timesheets turned on, like the app's Weekly tab.
export default {
  data() {
    return { projects: [] }
  },

  async created() {
    try {
      this.projects = await this.$store.dispatch('timesheet/myWeekProjects')
    } catch (e) {
      this.projects = []
    }
  },
}
</script>
